var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',{attrs:{"column":"","align-center":""}},[_c('h1',[_vm._v("404")]),_c('v-flex',{attrs:{"xs12":""}},[_c('h3',[_vm._v("Ресурс не найден")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }